import axios from 'axios'

export const save = params =>
   axios.post(window.URL_EVENT_SERVICE + 'event/save', params)

export const create = () =>
   axios.post(window.URL_EVENT_SERVICE + 'event/create')

export const saveMultiplePrices = (token, params) =>
   axios.post(window.URL_EVENT_SERVICE + 'price/savemultiple/' + token, params)

export const addPrice = params =>
   axios.post(window.URL_EVENT_SERVICE + 'price/save/', params)

export const removePrice = id =>
   axios.post(window.URL_EVENT_SERVICE + 'price/remove/', { id })

export const addCategory = params =>
   axios.post(window.URL_EVENT_SERVICE + 'category/save/', params)

export const removeCategory = id =>
   axios.post(window.URL_EVENT_SERVICE + 'category/remove/', { id })

export const loadTags = id =>
   axios.post(window.URL_EVENT_SERVICE + 'details/tags/', { id })

export const saveDetails = params =>
   axios.post(window.URL_EVENT_SERVICE + 'details/save/', params)

export const find = urlParams =>
   axios.get(window.URL_EVENT_SERVICE + 'event/find/?' + urlParams)

export const remove = id =>
   axios.post(window.URL_EVENT_SERVICE + 'event/remove/', { id })

export const getEvent = id =>
   axios.post(window.URL_EVENT_SERVICE + 'event/getfull/', { id })

export const getEventToken = token =>
   axios.get(window.URL_EVENT_SERVICE + 'event/getfull/' + token)

export const copy = id =>
   axios.post(window.URL_EVENT_SERVICE + 'event/copy/', { id })

export const removeCover = id =>
   axios.post(window.URL_EVENT_SERVICE + 'cover/remove/', { id })

export const uploadCover = (id, file, progress) => {
   let form = new FormData()
   form.append('id', id)
   form.append('cover', file)
   return axios.post(window.URL_EVENT_SERVICE + 'cover/save/', form, {
      onUploadProgress: progressEvent => {
          let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
          progress(percentCompleted)
      }
  })
}

export const saveCover =  (id, {image, cat}) =>
    axios.post(window.URL_EVENT_SERVICE + 'cover/save/', { id, image, cat })

export const publish = id =>
   axios.post(window.URL_EVENT_SERVICE + 'event/publish/', { id })

export const loadGallery = () =>
    axios.get(window.URL_EVENT_SERVICE + 'cover/gallery')



// WEBPACK FOOTER //
// ./src/App/Utils/event.js